/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-01-16 13:47:40
 * @LastEditors: pj
 * @LastEditTime: 2023-01-16 17:02:44
 */

/* eslint-disable */

import Vue from 'vue'
import Antd from 'ant-design-vue/lib'

Vue.use(Antd)